module.exports = __webpack_public_path__ + "img/showing_not_attended.086ae3b5.svg";